/**
 * Brutus prompt defaults, shared so the API and the portal render ONE copy.
 * The Brutus tab shows these in an editable textarea; a second copy in the
 * portal would drift from what the API actually sends.
 *
 * These are INSTRUCTIONS ONLY. The request's reference, type, title and
 * description are appended by `BrutusRunHandler` as a fixed block below the
 * instruction, and are deliberately not interpolated into it — see spec §5.3.
 * A template language here would let an admin delete a token and silently
 * hand an agent a prompt with no request in it.
 */
export const BRUTUS_DEFAULT_ANALYSIS_PROMPT = [
  'Investigate the customer request below against this project\'s codebase.',
  '',
  'Produce:',
  '1. A short root-cause assessment (for a defect) or feasibility assessment',
  '   (for a feature request).',
  '2. A numbered list of concrete implementation steps.',
  '3. The files most likely to change.',
  '',
  'This is an analysis only: do not modify, create, or delete any files, and',
  'do not open a pull request. Lead your reply with a 3-5 bullet summary.',
].join('\n');

export const BRUTUS_DEFAULT_EXECUTION_PROMPT = [
  'Carry out the implementation steps agreed in the analysis above.',
  '',
  'Work on a feature branch, keep the change scoped to what the analysis',
  'identified, and open a pull request when the work is complete. Finish your',
  'reply with a short statement of what changed and anything a reviewer',
  'should look at closely.',
].join('\n');

/**
 * Hard cap on the comment body posted to the DevStride work item. The full
 * text is always uploaded as an attachment, so this is a truncation, never a
 * loss. A mechanical cap rather than a trust that the model stayed brief:
 * the "lead with a summary" instruction above only improves what lands above
 * the cut, it does not guarantee one.
 */
export const BRUTUS_COMMENT_CHAR_LIMIT = 1200;

export const BRUTUS_TRUNCATION_MARKER =
  '… truncated — see the Brutus run for the full write-up.';
